import React from "react";
import PropTypes from "prop-types";

import { useTranslation } from "@common/hooks/translation";

const ClientTransactionClient = ({ data }) => {
  const t = useTranslation();

  return (
    <div className="ct-client">
      <h1 className="ct-client-name">
        {data.FirstName}
        &nbsp;
        {data.LastName}
      </h1>

      <p className="ct-client-id">
        {t("Id")}: &nbsp;
        <span>{data.Id}</span>
      </p>
      {data.PersonalId && (
        <p className="ct-client-id">
          {t("CNP")}: &nbsp;
          <span>{data.PersonalId}</span>
        </p>
      )}
    </div>
  );
};

ClientTransactionClient.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ClientTransactionClient;
